import React, { useCallback } from 'react';
import { useTrackEvent } from '@olxeu-a2b/delivery-utils/src/tracking';
import { InfoModalAsteriskTextKeys, TrackTermsAndConditionClick } from './types';
import { useI18n } from '../../i18n';

import S from './style/InfoModal';
import trackingKeys from '../constants/trackingKeys';

export interface TrackingExtras {
  seller_type: string;
  ad_id: string | number;
  seller_id: string;
  touch_point_page: string;
}

interface InfoModalAsteriskProps {
  asteriskTextKeys: InfoModalAsteriskTextKeys;
  asteriskLink: string;
  tracking?: TrackTermsAndConditionClick;
  source?: string;
  trackingExtras?: TrackingExtras;
}

const InfoModalAsterisk: React.FC<InfoModalAsteriskProps> = ({
  asteriskTextKeys,
  asteriskLink,
  tracking,
  source,
  trackingExtras,
}) => {
  const i18n = useI18n();
  const trackEvent = useTrackEvent();

  const { termsAndConditionsClick } = trackingKeys.events.safeDeal;

  const handleOnLinkClick = useCallback(() => {
    trackEvent(termsAndConditionsClick, null, null, trackingExtras);
    if (tracking) {
      return tracking(source);
    }
    return null;
  }, [tracking, source]);

  return (
    <S.AsteriskNote data-testid="info-modal-asterisk" data-cy="info-modal-asterisk">
      {asteriskTextKeys.description && <>{i18n(asteriskTextKeys.description)} </>}
      <S.Link
        href={asteriskLink}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleOnLinkClick}
        data-testid="info-modal-asterisk-link"
      >
        {i18n(asteriskTextKeys.link)}
      </S.Link>
    </S.AsteriskNote>
  );
};

export default InfoModalAsterisk;
